// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NQU2","index":"styles_index__rJp3a"};